import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createThreadUseCase } from "../../../api";
import { useAuth } from "../../../hooks";
import { Experience3d } from "../../../components/NewAssistence3d";

//const assistanceApiController = new AssistanceApi();

export function NewAssistance3d() {
  const { assistantId } = useParams();
  const { accessToken } = useAuth();
  const [threadId, setThreadId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (assistantId && accessToken) {
        try {
          const threadId = await createThreadUseCase(accessToken, assistantId);
          setThreadId(threadId);
          localStorage.setItem("threadId", threadId);
        } catch (error) {
          console.error("Error en las llamadas asincrónicas:", error);
        }
      } else {
        console.error(
          "No se proporcionó un ID de asistente en la URL o falta el accessToken",
        );
      }
    };
    fetchData();
  }, [assistantId, accessToken]);

  return (
    <div>
      <Experience3d
        accessToken={accessToken}
        threadId={threadId}
        assistantId={assistantId}
        useAccessToken={true}
      />
    </div>
  );
}
